<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    max-width="max-w-[500px]"
    min-height="min-h-[250px]"
    @close="$emit('close')"
  >
    <div class="flex h-full flex-col justify-between gap-4 px-4">
      <h2 class="-mt-4 text-left text-xl text-steel-1100">
        Confirm Withdrawal
      </h2>

      <div class="flex flex-col gap-3">
        <p class="text-left font-normal text-steel-900">
          Your current offer will be withdrawn, and the broker will be notified.
          You can place a new offer on this load again.
        </p>
        <p class="text-left font-normal text-steel-900">
          Do you want to withdraw your offer?
        </p>
      </div>

      <div
        class="mb-2 mt-8 flex justify-end gap-2 [&>*]:flex-1 md:[&>*]:flex-initial"
      >
        <ButtonComponent
          class="min-w-[75px] md:w-min"
          @click="$emit('cancel')"
        >
          Cancel
        </ButtonComponent>
        <ButtonComponent
          variant="primary"
          class="md:w-[150px]"
          :is-loading="isLoading"
          @click="handleWithdraw"
        >
          Yes Withdraw
        </ButtonComponent>
      </div>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { BottomSheet, ButtonComponent } from '@/components';

const store = useStore();
const toast = useToast();

const props = defineProps({
  visible: Boolean,
  offer: {
    type: Object,
    required: false,
  },
});

const emit = defineEmits(['close', 'cancel']);

const isLoading = ref(false);

const handleWithdraw = async () => {
  isLoading.value = true;

  const offer = props?.offer || store.state.loads?.offer;
  const company_id = props?.offer?.load?.broker_company_id;

  const res = await store.dispatch('loads/withdrawOffer', {
    id: offer?.id,
  });

  if ([200, 201, 204].includes(res.status)) {
    await toast.open({
      message: 'Offer withdrawn',
      position: 'top-right',
      duration: 5000,
    });

    if (props?.offer?.id) {
      const findBrokerWaitingOffers = store.state.loads?.waiting_offers?.find(
        (el) => el.company_id === company_id
      );

      if (findBrokerWaitingOffers?.offers?.length === 1) {
        await store.dispatch('loads/getOffersByType', {
          type: 'waiting',
        });
      }

      await store.dispatch('loads/getOffersByCompanyId', {
        company_id,
        type: 'waiting',
      });
    } else {
      await store.dispatch('loads/getOfferByLoadId', {
        load_id: store.state.loads?.load_details?.id,
      });
    }

    isLoading.value = false;
    emit('close');
  } else {
    await toast.open({
      message: 'Unexpected error. Please try again.',
      type: 'error',
      position: 'top-right',
      duration: 5000,
    });

    isLoading.value = false;
  }

  isLoading.value = false;
};
</script>
